import { Valence } from '@upright/common/model/types';
import { ElbowConnectors } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/connectors/elbow-connectors';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { valenceToSide } from '@upright/ui/common/upright/core/impact-lens-profile/common/utils';
import { useInsightsLensContext } from '@upright/ui/common/upright/core/impact-lenses/insights/common/use-insights-lens-context';
import { getInsightInfoBoxDataWithBoundsForSelection } from '@upright/ui/common/upright/core/impact-lenses/insights/common/utils';
import { useCarouselContext, useCarouselLayout, useImpactBarsLayout } from '../../../impact-lens-profile/context';

export function InsightsInfoBoxConnectors() {
  const { lensIndex, previousLensIndex } = useCarouselContext();
  const baseLayout = useCarouselLayout();
  const lensContext = useInsightsLensContext();
  const layout = useImpactBarsLayout();
  if (!lensContext || baseLayout.boxMode === LensBoxMode.MODAL) {
    return <></>;
  }
  const insights = lensContext.data.insights;
  if (!insights) {
    return <></>;
  }
  const boxData = getInsightInfoBoxDataWithBoundsForSelection(
    baseLayout,
    insights,
    lensIndex,
    previousLensIndex,
    lensContext.selection,
  );

  const connectors = boxData.map(d => {
    const x1 = d.valence === Valence.POSITIVE ? d.bounds.x1 : d.bounds.x2;
    const y1 = d.bounds.y1 + d.bounds.height / 2;
    const sa = layout.impactBarArea(valenceToSide(d.valence), d.impact);
    const x2 = d.valence === Valence.POSITIVE ? sa.x2 : sa.x1;
    const y2 = sa.y1 + sa.height / 2;
    return { x1, x2, y1, y2 };
  });
  return <ElbowConnectors connectors={connectors} />;
}
